export function extractCursor(url: string | null): string | undefined {
  if (!url) {
    return undefined
  }

  try {
    const urlObj = new URL(url)
    return urlObj.searchParams.get('cursor') || undefined
  } catch {
    return undefined
  }
}
